// MARCA | 09/10/2026 | Landing page free gift for landing Habit Builder widgets (page.offer-v1 / page.offer-v2).
// MARCA | 09/10/2026 | Supports up to two gifts (data-free-gift-variant-id / -id-2), both tagged _landing_gift_source: ad_landing_promo.
// MARCA | 09/10/2026 | Gifts are only added with a subscription (selling plan).
// MARCA | 09/10/2026 | Landing widgets now go straight to checkout instead of adding to cart: the cart is replaced with the
// MARCA | 09/10/2026 | selected product (subscription or Trial Pack) plus any gifts, then the customer is sent to /checkout.
// MARCA | 09/10/2026 | Only widgets with data-landing-purchase-options (landing snippets) are affected; other pages keep product-form.js.

// MARCA | 09/10/2026 | Guard so the handler is defined once even if both landing widgets load this file.
if (!window.MarcaLandingFreeGift) {
  const GIFT_PROPERTY_KEY = "_landing_gift_source";
  const GIFT_PROPERTY_VALUE = "ad_landing_promo";
  const WIDGET_SELECTOR = "[data-landing-purchase-options]";
  // MARCA | 09/10/2026 | Gift 1 and gift 2 variant ID attributes rendered by landing-free-gift-attributes.liquid.
  const GIFT_VARIANT_ATTRIBUTES = ["data-free-gift-variant-id", "data-free-gift-variant-id-2"];

  class MarcaLandingFreeGift {
    constructor(widget) {
      this.widget = widget;
      this.sectionId = widget.dataset.sectionId;
      this.section = widget.closest("section");
      this.form = this.section?.querySelector(`#product-form-${this.sectionId}`);
      this.productForm = this.form?.closest("product-form");
      this.onSubmit = this.onSubmit.bind(this);
    }

    // MARCA | 09/10/2026 | Capture on <product-form> runs before the form's own submit listeners (product-form.js, custom-subs.js).
    init() {
      if (!this.form || !this.productForm) return;
      if (this.productForm.dataset.landingFreeGiftBound === "true") return;
      this.productForm.dataset.landingFreeGiftBound = "true";
      this.productForm.addEventListener("submit", this.onSubmit, { capture: true });

      // MARCA | 09/10/2026 | Back from checkout restores this page from the bfcache with the button still loading; reset it.
      window.addEventListener("pageshow", (event) => {
        if (event.persisted) this.setLoading(false);
      });
    }

    // MARCA | 09/10/2026 | Returns gift 1 and gift 2 variant IDs (either may be missing). getAttribute is used because
    // MARCA | 09/10/2026 | dataset does not camelCase "-2", and duplicates are dropped if the same gift is set twice.
    getGiftVariantIds() {
      const currentWidget =
        this.section?.querySelector(
          `${WIDGET_SELECTOR}[data-section-id="${this.sectionId}"]`,
        ) || this.widget;
      const giftVariantIds = GIFT_VARIANT_ATTRIBUTES.map((attribute) =>
        Number(currentWidget.getAttribute(attribute) || 0),
      ).filter(Boolean);
      return [...new Set(giftVariantIds)];
    }

    // MARCA | 09/10/2026 | Disabled selling_plan inputs (one-time purchase) are excluded from FormData, so 0 means no subscription.
    getSelectedSellingPlanId() {
      return Number(new FormData(this.form).get("selling_plan") || 0);
    }

    // MARCA | 09/10/2026 | Every landing widget submit goes to checkout; gifts are only included with a subscription.
    onSubmit(event) {
      if (event.target !== this.form) return;

      event.preventDefault();
      event.stopPropagation();

      if (this.productForm.submitButton?.getAttribute("aria-disabled") === "true") return;

      const giftVariantIds = this.getSelectedSellingPlanId() ? this.getGiftVariantIds() : [];
      this.submitToCheckout(giftVariantIds);
    }

    generateSubscriptionLineId() {
      return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    }

    // MARCA | 09/10/2026 | Mirrors the form state written by custom-subs.js (variant id, selling plan, line item properties).
    buildMainItem() {
      const formData = new FormData(this.form);
      const sellingPlanId = Number(formData.get("selling_plan") || 0);
      const item = {
        id: Number(formData.get("id")),
        quantity: Math.max(1, Number(formData.get("quantity")) || 1),
      };

      const properties = {};
      formData.forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && typeof value === "string" && value !== "") {
          properties[match[1]] = value;
        }
      });

      // MARCA | 09/10/2026 | custom-subs.js normally adds this in its own submit listener, which is skipped on this path.
      if (sellingPlanId) {
        item.selling_plan = sellingPlanId;
        properties._subscription_line_id = this.generateSubscriptionLineId();
      } else {
        delete properties._subscription_line_id;
      }

      if (Object.keys(properties).length) item.properties = properties;
      return item;
    }

    buildGiftItem(giftVariantId) {
      return {
        id: giftVariantId,
        quantity: 1,
        properties: {
          [GIFT_PROPERTY_KEY]: GIFT_PROPERTY_VALUE,
        },
      };
    }

    getCartAddUrl() {
      const cartAddUrl = window.routes?.cart_add_url || "/cart/add";
      return cartAddUrl.endsWith(".js") ? cartAddUrl : `${cartAddUrl}.js`;
    }

    // MARCA | 09/10/2026 | Cart clear endpoint (locale-aware via routes.cart_url) used to replace the cart before checkout.
    getCartClearUrl() {
      const cartUrl = window.routes?.cart_url || "/cart";
      return `${cartUrl.replace(/\.js$/, "")}/clear.js`;
    }

    // MARCA | 09/10/2026 | Locale-aware checkout URL.
    getCheckoutUrl() {
      const root = window.Shopify?.routes?.root || "/";
      return `${root.endsWith("/") ? root : `${root}/`}checkout`;
    }

    // MARCA | 09/10/2026 | Empties the cart so checkout contains only this purchase and its gifts (also stops a Back + re-click
    // MARCA | 09/10/2026 | from creating a second subscription line or a second gift).
    async clearCart() {
      const response = await fetch(this.getCartClearUrl(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      if (!response.ok) throw new Error(`Cart clear failed (${response.status})`);
    }

    // MARCA | 09/10/2026 | Requests to try in order: main + all gifts, then main + each gift alone, then main only.
    getItemAttempts(mainItem, giftVariantIds) {
      const giftItems = giftVariantIds.map((giftVariantId) => this.buildGiftItem(giftVariantId));
      const attempts = [[mainItem, ...giftItems]];

      if (giftItems.length > 1) {
        giftItems.forEach((skippedGift) => {
          attempts.push([mainItem, ...giftItems.filter((giftItem) => giftItem !== skippedGift)]);
        });
      }

      if (giftItems.length) attempts.push([mainItem]);
      return attempts;
    }

    // MARCA | 09/10/2026 | Sections are no longer requested because the page navigates to checkout instead of rendering the drawer.
    async postItems(items) {
      const response = await fetch(this.getCartAddUrl(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ items }),
      });
      return response.json();
    }

    // MARCA | 09/10/2026 | Replaces submitWithGifts: clear cart, add main item (+ gifts), then redirect to checkout.
    async submitToCheckout(giftVariantIds) {
      const mainItem = this.buildMainItem();
      if (!mainItem.id) return;

      this.productForm.handleErrorMessage?.();
      this.setLoading(true);

      let isRedirecting = false;
      try {
        await this.clearCart();

        // MARCA | 09/10/2026 | If a request fails (e.g. a gift sold out), drop gifts one at a time, then main only, so the sale is not blocked.
        const attempts = this.getItemAttempts(mainItem, giftVariantIds);
        let response;
        for (let index = 0; index < attempts.length; index += 1) {
          response = await this.postItems(attempts[index]);
          if (!response.status) break;

          const nextAttempt = attempts[index + 1];
          if (nextAttempt) {
            const nextGiftIds = nextAttempt.slice(1).map((item) => item.id);
            console.warn(
              nextGiftIds.length
                ? `[MARCA Landing Free Gift] Gifts not added, retrying with gift ${nextGiftIds.join(", ")} only`
                : "[MARCA Landing Free Gift] Gift not added, retrying main product only",
              response,
            );
          }
        }

        if (response.status) {
          this.handleError(response, mainItem);
          return;
        }

        isRedirecting = true;
        window.location.assign(this.getCheckoutUrl());
      } catch (error) {
        console.error("[MARCA Landing Free Gift]", error);
        this.productForm.handleErrorMessage?.(window.cartStrings?.error || error.message);
      } finally {
        // MARCA | 09/10/2026 | Keep the spinner while the browser navigates to checkout; clear it on errors.
        if (!isRedirecting) this.setLoading(false);
      }
    }

    // MARCA | 09/10/2026 | The cart was cleared before the failed add, so the drawer is refreshed to match.
    handleError(response, mainItem) {
      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        publish(PUB_SUB_EVENTS.cartError, {
          source: "landing-free-gift",
          productVariantId: mainItem.id,
          errors: response.errors || response.description,
          message: response.message,
        });
      }
      this.productForm.handleErrorMessage?.(response.description || response.message);
      this.productForm.dispatchEvent(
        new CustomEvent("cart-drawer:refresh", {
          detail: { response },
          bubbles: true,
          composed: true,
        }),
      );
    }

    setLoading(isLoading) {
      const submitButton = this.productForm.submitButton;
      const loader = this.productForm.querySelector(".loading-overlay__spinner");
      if (!submitButton) return;

      if (isLoading) {
        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        loader?.classList.remove("hidden");
        return;
      }

      submitButton.removeAttribute("aria-disabled");
      submitButton.classList.remove("loading");
      loader?.classList.add("hidden");
    }
  }

  window.MarcaLandingFreeGift = MarcaLandingFreeGift;

  const initMarcaLandingFreeGift = (scope = document) => {
    scope.querySelectorAll(WIDGET_SELECTOR).forEach((widget) => {
      new MarcaLandingFreeGift(widget).init();
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initMarcaLandingFreeGift());
  } else {
    initMarcaLandingFreeGift();
  }

  // MARCA | 09/10/2026 | Re-bind after Theme Editor re-renders the section (e.g. gift product changed).
  document.addEventListener("shopify:section:load", (event) => {
    initMarcaLandingFreeGift(event.target);
  });
}
